import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=2cfd50b9&scoped=true"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=2cfd50b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd50b9",
  null
  
)

export default component.exports